import { useLocalization } from '../../../context/LocalizationContext';
import closeIcon from '../../../assets/icons/newDesign/close.svg';
import Button from '../Button';
import './Modal.css';

const Modal = ({ isOpen, onClose, title, message, children = undefined, noScroll = false, customLayout = false, closeVisible = true }) => {
  const { t } = useLocalization();

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className={`modal-content ${customLayout ? 'modal-content-custom' : ''} ${noScroll ? 'modal-content-no-scroll' : ''}`}
        onClick={(e) => e.stopPropagation()}
      >
        {customLayout ? (
          <>
            {closeVisible && <button className="modal-close-icon" onClick={onClose} aria-label="Close">
              <img src={closeIcon} alt="Close" />
            </button>}
            {children}
          </>
        ) : (
          <div className="modal-body-standard">
            {title && <h2 className="modal-title">{title}</h2>}
            {message && <p className="modal-message">{message}</p>}
            {children}
            <div className="modal-actions-standard">
              <Button variant="secondary" onClick={onClose}>
                {t('close')}
              </Button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Modal;
